export default __webpack_public_path__ + "static/media/Investors-Meet-11-09-2026.9a205527.pdf";